// extracted by mini-css-extract-plugin
export default {"LeftBox":"LeftBox_LeftBox__g8rHX","BgImage":"LeftBox_BgImage__Qj8Im"};